import React, { PropTypes, Component } from 'react'
import styles from './styles'
import TimeSheet from 'components/timesheet'
import HeaderCell from './headerCell'
import HeaderAutocompleteCell from './headerAutocompleteCell'
import RecordCell from './recordCell'
import SummaryCell from './summaryCell'
import misc from 'utils/misc'

export default class TimeSheetCell extends Component {
  static propTypes = {
    data: PropTypes.object,
    userId: PropTypes.string,
    projectId: PropTypes.string,
    taskId: PropTypes.string,
    weekDay: PropTypes.number,
    type: PropTypes.string,
    onRecordUpdate: PropTypes.func,
    readOnly: PropTypes.bool,
  };

  constructor (props, context) {
    super(props, context)
  }

  shouldComponentUpdate (nextProps) {
    return (
      this.props.data.text !== nextProps.data.text ||
      this.props.data.nTime !== nextProps.data.nTime ||
      this.props.data.oTime !== nextProps.data.oTime ||
      (misc.isObjectEqual(this.props.data.items, nextProps.data.items)) ||
      this.props.data.note !== nextProps.data.note ||
      this.props.data.type !== nextProps.data.type ||
      this.props.data.colType !== nextProps.data.colType ||
      this.props.data.rowType !== nextProps.data.rowType ||
      this.props.userId !== nextProps.userId ||
      this.props.projectId !== nextProps.projectId ||
      this.props.taskId !== nextProps.taskId ||
      this.props.weekDay !== nextProps.weekDay ||
      this.props.readOnly !== nextProps.readOnly ||
      this.props.data.allNotes !== nextProps.data.allNotes
    )
  }

  static Type = {
    text: 'textCell',
    autocomplete: 'autocompleteCell',
    record: 'recordCell',
    summary: 'summaryCell',
  };

  render () {
    const { colType, rowType, text, c, ...props } = this.props.data
    const readOnlyStyle = this.props.readOnly ? styles.readOnly : ''
    const baseClass = `${styles.cell} ${styles[rowType]} ${styles[colType]} ${readOnlyStyle}`
    const isProjectCol = c === 0
    const isTaskCol = c === 1

    if (isTaskCol && rowType === TimeSheet.RowType.record) {
      if (this.props.readOnly) {
        return <HeaderCell {...{ baseClass, text, cellHint: false }} />
      }
      return <HeaderAutocompleteCell {...{ baseClass, text, ...props }} />
    } else if (colType === TimeSheet.ColType.header ||
               rowType === TimeSheet.RowType.header) {
      const cellHint = rowType === TimeSheet.RowType.record && isProjectCol
      return <HeaderCell {...{ baseClass, text, cellHint }} />
    } else if (colType === TimeSheet.ColType.day) {
      return <RecordCell className={baseClass} {...this.props} />
    }
    return <SummaryCell className={baseClass} {...this.props} />
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/index.jsx